<template>
  <div class="home">
    <div class="hero-container">
      <div class="hero-bar">
        <div class="hero-bar--content">
          <h2>Eugene Daily</h2>
          <p>
            Senior Software Engineer with experience designing, building, and maintaining Developer and Cloud Platforms.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";

export default {
  name: "home",
  components: {
    Navigation,
  },
};
</script>
<style scoped>
#portfolio-link {
  font-weight: 600;
  color: #4696db;
}

a {
  /* text-decoration: none; */
  color: rgb(95, 95, 95);
  transition: all 0.2s ease;
}
a:hover {
  color: #62abeb;
}

ul {
  margin-top: 10px;
}
li {
  font-size: 14px;
  color: rgb(95, 95, 95);
}

.red {
  background-color: #b9d7f1;
}

.table {
  margin-bottom: 20px;
}

.columns {
  margin: 30px 10px 30px 10px;

  display: grid;
  text-align: left;

  grid-template-columns: 1fr 2fr 120px;
}
.col-left {
  font-size: 0.7em;
  color: rgb(168, 168, 168);
  text-transform: uppercase;
}
.col-right {
  text-align: right;
  font-size: 0.7em;
  text-transform: uppercase;
  color: rgb(168, 168, 168);
}

small {
  color: rgb(168, 168, 168);
}

.hero-container {
  min-height: 300px;
  margin: 10px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: -o-flex;
  display: flex;
  justify-content: center;
  align-items: center;

  line-height: 1.8em;
}

.hero-bar h2 {
  font-size: 1em;
  text-align: left;
  margin: 0px;
  text-transform: uppercase;
}

.hero-bar {
  display: grid;
  grid-template-columns: 2fr 1fr;
}

.hero-bar p {
  text-align: left;
}
.hero-bar--content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: -o-flex;
  display: flex;

  flex-direction: column;
  justify-content: center;
}

.hero-bar--image {
  display: flex;
  justify-content: flex-end;
}

.hero-bar--image img {
  height: 200px;
  border-radius: 50%;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
}

@media all and (max-width: 760px) {
  .hero-bar {
    display: flex;

    flex-direction: column;
  }
  .hero-bar--image {
    justify-content: center;
  }
  .hero-bar--image img {
    display: none;
  }
}

@media all and (max-width: 700px) {
  .columns {
    grid-column: 1fr;
    grid-template-columns: 1fr;
  }
}
</style>
